import React from 'react';
import * as Mui from '@mui/material';
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { styles } from './styles';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { RoundRobinRoute } from "model/round-robin-route";
import { Avatar } from "component/shared/avatar";
import { FeatherIcon } from "component/shared/feather-icon";
import * as Icons from "react-feather";

interface Props extends OwnProps, WithStyles<typeof styles> {}

interface OwnProps {
	roundRobinRoute: RoundRobinRoute;
	position: number;
	isNext?: boolean;
	dragHandleProps?: any;
	disableUp?: boolean;
	disableDown?: boolean;
	onMoveUp: () => void;
	onMoveDown: () => void;
	onDelete: () => void;
}

class Component extends React.Component<Props> {
	render() {
		const { classes = {}, position, isNext, roundRobinRoute, dragHandleProps, disableUp, disableDown, onMoveUp, onMoveDown, onDelete } = this.props;
		return (
			<Mui.Box display="flex" alignItems="center" style={{ padding: "12px 16px", gap: 12 }}>
				<span {...dragHandleProps} className={classes.dragHandle}>
					<DragIndicatorIcon />
				</span>
				<Avatar phrase={roundRobinRoute.agent.label} src={roundRobinRoute.agent.photoUrl} />
				<Mui.Typography>{roundRobinRoute.agent.label}</Mui.Typography>
				{isNext && (
					<Mui.Chip label="Next up" size="small" className={classes.nextChip} />
				)}
				<div style={{ flexGrow: 1 }} />
				<div className={classes.stepper}>
					<div className={classes.stepperValue}>{position}</div>
					<div className={classes.stepperButtons}>
						<Mui.IconButton size="small" color="primary" className={classes.stepperButton} disabled={disableUp} onClick={onMoveUp}>
							<Icons.ChevronUp size={16} />
						</Mui.IconButton>
						<Mui.IconButton size="small" color="primary" className={classes.stepperButton} disabled={disableDown} onClick={onMoveDown}>
							<Icons.ChevronDown size={16} />
						</Mui.IconButton>
					</div>
				</div>
				<Mui.Tooltip title="Remove Agent from Rotation">
					<Mui.IconButton
						size="small"
						color="primary"
						onClick={onDelete}
					>
						<FeatherIcon fontSize="small">
							<Icons.Trash />
						</FeatherIcon>
					</Mui.IconButton>
				</Mui.Tooltip>
			</Mui.Box>
		);
	}
}

export const RefreshCard = withStyles(Component, styles);
